"use client";

import { useEffect } from "react";

import UnknownError from "@/app/errors/unknownError";

/**
 * Error boundary for app-level errors.
 * IMPORTANT: This component must only use client-safe components.
 * Do NOT import Server Components (like StandardPage) here, as this
 * will cause "async client component" errors when Next.js tries to
 * render the error page on the client after an exception.
 */
export default function ErrorPage({ error, reset }: { error: Error; reset: () => void }) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div id="error-page-container">
      <UnknownError error={error} />
    </div>
  );
}
